import { partition } from 'lodash';

import { TreeNode } from '@work4all/components/lib/dataDisplay/tree/types';

import { LookUp } from '@work4all/models/lib/Classes/LookUp.entity';

export function groupResourceClasses(
  resourceClasses: LookUp[],
  getLabel: (name: string | null) => string
): TreeNode[] {
  const [withGroup, withoutGroup] = partition(
    resourceClasses,
    (item) => item.textValue
  );

  const topLevelResults: TreeNode[] = withoutGroup.map((item) => ({
    id: item.id.toString(),
    label: getLabel(item.name),
  }));

  const grouped = withGroup.reduce<Record<string, LookUp[]>>((acc, item) => {
    const key = item.textValue;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(item);
    return acc;
  }, {});

  const groupedResults: TreeNode[] = Object.entries(grouped).map(
    ([key, items]) => ({
      id: key,
      label: key,
      children: items.map((item) => ({
        id: item.id.toString(),
        label: getLabel(item.name),
      })),
    })
  );

  return [...topLevelResults, ...groupedResults];
}
